<template>
    <modal v-model="open" :style="cssVars" :size="size" :append-to-body="true" :backdrop="false" @close="onClose">
        <span slot="header" v-if="title"><span v-if="headericon" :class="'glyphicon glyphicon-'+headericon"></span> <strong v-html="title"></strong></span>
        <template v-for="(index, name) in $slots" v-slot:[name]>
          <slot :name="name" />
        </template>
        <slot></slot>
        <span slot="footer" v-if="!waitbuttons">
            <btn v-if="closebutton" type="default" @click="closeDialog"><span class="glyphicon glyphicon-close"></span> Закрыть</btn>
            <template v-if="buttons">
                <btn v-for="(button,i) in buttons" :key="i" :type="button.type" @click="button.action" :title="button.hint"><span v-if="button.icon" :class="'glyphicon glyphicon-'+button.icon"></span> <span v-html="button.title"></span></btn>
            </template>
            <btn v-if="acceptbutton" type="success" @click="acceptbutton"><span class="glyphicon glyphicon-ok"></span> Внести</btn>
        </span>
        <span slot="footer" v-else>
            <btn type="default"><span class="glyphicon glyphicon-clock"></span> Ожидайте...</btn>
        </span>
    </modal>
</template>
<style scoped>

    /deep/ div.modal-header
    {
        background-color:var(--bg-color);
    }

    /deep/ .modal-content{ overflow:hidden; }

    .modal {
        text-align:center;
    }

    /deep/ .modal-dialog {
        text-align:left;
        max-width: 100%;
        width: auto !important;
        display:inline-block;
    }

    /deep/ .select2-container--open {
        z-index: 9999999
    }

</style>

<script>

export default {
        props:["value","headerclass","closebutton","acceptbutton","buttons","headericon","title","size","waitbuttons"],
        data(){
            return { 
                open:false,
                colors:{
                    info:"#d9edf7",
                    primary:"#337ab7",
                    success:"#dff0d8",
                    warning:"#fcf8e3",
                    danger:"#f2dede"
                }
            };
        },
        computed:{
            cssVars(){
                let obj={ };
                if (this.headerclass)
                    obj['--bg-color']=this.colors[this.headerclass];
                return obj;
            },
        },
        methods:{
            closeDialog(){
                this.open=false;
                this.$emit("input",false);
            },
            onClose(){
                this.$emit("input",false);
            }
        },
        watch:{
            value(){
                this.open=this.value;
            }
        }
    }

</script>